import { AccordionBodyItem } from 'component/Accordion';
import { SelectComponent } from 'component/Select';
import React, { useEffect, useState } from 'react';
import { getOrganizationsRestricted } from 'api/OrganizationsApi';
import { EORE_ORGANIZATION_OPTIONS } from 'consts/Organizations';

export const ReporterOrganization = (props) => {
  const { formData } = props;
  const [options, setOptions] = useState(EORE_ORGANIZATION_OPTIONS);

  useEffect(() => {
    getOrganizationsRestricted()
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length) {
          setOptions(data.map((org) => ({ value: org.name, label: org.name })));
        }
      })
      .catch((error) => {
        console.error('Error fetching organizations:', error);
      });
  }, []);

  const updateReporterOrganization = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        general: {
          ...prevFormData.info.general,
          reporter_organization: value,
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>1.5</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Організація, що звітує"
      titleEN="Reporting organization"
      className={props.errors?.general?.reporter_organization ? 'error' : ''}
      children={(
        <SelectComponent
          options={options}
          value={options.find(
            (option) => option.value === formData?.info?.general?.reporter_organization
          ) || options[0]}
          handleSelect={updateReporterOrganization}
        />
      )}
    />
  );
};
